module.exports = __webpack_public_path__ + "img/telhado-trapezoidal.6d624806.jpg";